import { render, staticRenderFns } from "./DatatablePaginationItem.vue?vue&type=template&id=66e9c152&"
import script from "./DatatablePaginationItem.vue?vue&type=script&lang=js&"
export * from "./DatatablePaginationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports